import React, { useEffect } from 'react';
import { Switch } from 'react-router-dom';
import posed, { PoseGroup } from 'react-pose';
import { goesBack } from '../utils/utils';

const routeChanged = () => goesBack(false);

export const AnimatedSwitch = ({
  location, children
}) => {
  useEffect(() => {
    window.addEventListener('popstate', routeChanged);
    return () => window.removeEventListener('popstate', routeChanged);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <PoseGroup
      preEnterPose={goesBack() ? 'leftSide' : 'rightSide'}
      exitPose={goesBack() ? 'rightSide' : 'leftSide'}
    >
      <ContextRouteAnimation key={location.pathname} reverse={goesBack()}>
        <Switch location={location} key={location.pathname}>
          {children}
        </Switch>
      </ContextRouteAnimation>
    </PoseGroup>
  );
};

export default AnimatedSwitch;
/**
 * Try to change up the different commented values for varying animatmions
 */
export const ContextRouteAnimation = posed.div({
  enter: {
    x: 0,
    transition: {
      opacity: 1,
      type: 'tween',
      ease: 'easeInOut',
      duration: 400
    }
  },
  leftSide: {
    x: '-100%',
    transition: {
      opacity: 0,
      type: 'tween',
      ease: 'easeInOut',
      duration: 400
    }
  },
  rightSide: {
    x: '100%',
    transition: {
      opacity: 0,
      type: 'tween',
      ease: 'easeInOut',
      duration: 400
    }
  }
});
